export default{
	 CLOSE_PUSH_VIEW:"您确定退出直播间吗？",
}


// WEBPACK FOOTER //
// ./src/assets/js/language.js